export default __webpack_public_path__ + "static/media/italy.c157e934.svg";